import { Component, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { PlaybookActions } from '@src/suite/common/store/playbook/playbook.actions';
import { AppService } from '@suite/app.service';

@Component({
    selector: 'st-pager',
    templateUrl: './pager.html',
    styleUrls: ['./pager.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-pager',
    },
})
export class PagerComponent {
    private store = inject(Store);

    @Input()
    public pageSize: number = 7;

    get prevDisabled(): boolean {
        return this.startIndex === 0;
    }

    get nextDisabled(): boolean {
        return this.startIndex + this.visibleItemsCount === this.totalCount;
    }

    public get label(): string {
        return `${this.startIndex + 1} - ${this.startIndex + this.visibleItemsCount} of ${this.totalCount}`;
    }

    private _visibleItemsCount: number = 0;
    public get visibleItemsCount(): number {
        this._visibleItemsCount = this.pageSize;
        if (this.totalCount < this.pageSize) {
            this._visibleItemsCount = this.totalCount;
        } else if (this.totalCount < this._visibleItemsCount) {
            this._visibleItemsCount = this.totalCount;
        } else if (this.totalCount < this.startIndex + this.pageSize) {
            this._visibleItemsCount = this.totalCount - this.startIndex;
        }
        return this._visibleItemsCount;
    }

    private _totalCount: number = 0;
    @Input()
    public get totalCount(): number {
        return this._totalCount;
    }
    public set totalCount(count: number) {
        if (count !== this._totalCount) {
            this.startIndex = 0;
            this._totalCount = count;
            this.changeEmitter.emit({ startIndex: this.startIndex, pageSize: this.pageSize });
        }
    }

    @Output() public changeEmitter = new EventEmitter();

    public startIndex: number = 0;

    constructor(public appService: AppService) {}

    public prev() {
        if (this.prevDisabled) {
            return;
        }
        // 1. move to prev page
        // new start index becomes startIndex - pageSize
        this.startIndex -= this.pageSize;
        // 2. update timeline data
        this.store.dispatch(PlaybookActions.setStartIndex({ startIndex: this.startIndex }));
    }

    public next() {
        if (this.nextDisabled) {
            return;
        }
        // 1. move to next page
        // new start index becomes startIndex + pageSize
        this.startIndex += this.pageSize;
        // 2. update timeline data
        this.store.dispatch(PlaybookActions.setStartIndex({ startIndex: this.startIndex }));
    }
}
